import { Stack } from '@mui/material'
import { observer } from 'mobx-react-lite'

interface Props {
  value: React.ReactNode
}

export const MultiLineTextCell = observer(({ value }: Props) => {
  return <Stack sx={{ whiteSpace: 'normal' }}>{value}</Stack>
})
